export default __webpack_public_path__ + "static/media/resend-unopened.65dfa608.svg";